import React, { useState, useEffect } from 'react';
import _ from 'lodash';
import { connect } from 'react-redux';
import ImagesCell from 'shared-components/ImagesCell/ImagesCell';
import { requestUpdateProducts } from 'services/actions/adminActions';
import campaignModel from '../../campaignModel';
import SaveCloseActions from './SaveCloseActions';

import RenderInput from './RenderInput';

const EditRow = ({
  setRowsBeingEdited,
  row,
  updateProducts,
  campaignId,
  fetchingUpdatedProducts,
  imagesOpen,
  setImagesOpen,
  variants,
  categories,
}) => {
  const { legacyPostId: rowId, productId } = row;
  const [rowValues, setRowValues] = useState({});
  const handleRowValueChange = (name, value) => {
    setRowValues((prevState) => {
      return {
        ...prevState,
        [name]: value,
      };
    });
  };
  useEffect(() => {
    setRowValues(row);
  }, []);
  return (
    <tr key={rowId} className="edit">
      {_.map(campaignModel, (col) => {
        const { key, type } = col;
        const imageKey = key === 'galleryUrls' || key === 'imageUrl';
        return (
          <td key={key} className={type}>
            {imageKey ? (
              <ImagesCell
                images={rowValues[key]}
                rowId={rowId}
                type={key}
                imagesOpen={imagesOpen}
                openTooltip={() => setImagesOpen(`${rowId}-${key}`)}
                closeTooltip={() => setImagesOpen(null)}
              />
            ) : (
              <RenderInput
                rowValues={rowValues}
                handleRowValueChange={handleRowValueChange}
                column={col}
                row={row}
                campaignId={campaignId}
                updateProducts={updateProducts}
                categories={categories}
                loading={fetchingUpdatedProducts[rowId]}
                variants={variants[productId]}
              />
            )}
          </td>
        );
      })}
      <SaveCloseActions
        rowId={rowId}
        loading={fetchingUpdatedProducts[rowId]}
        setRowsBeingEdited={setRowsBeingEdited}
        rowValues={rowValues}
        variants={variants[productId]}
        updateProducts={updateProducts}
        campaignId={campaignId}
      />
    </tr>
  );
};

const mapStateToProps = (state, ownProps) => ({
  fetchingUpdatedProducts: state.adminState.fetchingUpdatedProducts,
  variants: state.adminState.variants,
  ...ownProps,
});

const mapDispatchToProps = {
  updateProducts: requestUpdateProducts,
};

export default connect(mapStateToProps, mapDispatchToProps)(EditRow);
